import axios from 'axios';
import { BASE_API_URL } from '../config';

const apiClient = axios.create({
  baseURL: BASE_API_URL
});

// Inject token and adjust headers for FormData
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwtToken') || sessionStorage.getItem('jwtToken');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Detect FormData and avoid setting Content-Type manually
  if (config.data instanceof FormData) {
    // Let the browser set the correct multipart/form-data boundary
    config.headers['Content-Type'] = 'multipart/form-data';
  } else {
    config.headers['Content-Type'] = 'application/json';
  }

  return config;
});

// Optional: handle global errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // You can log or transform errors here
    return Promise.reject(error);
  }
);

export default apiClient;
